import React from "react";

import "../CSS/Dashboard.css";
import DashboardContent from "../AdminComponents/Dashboard/DashboardContent";

function Dashboard() {
  return <DashboardContent />;
}

export default Dashboard;
